import { BUTTON_SIZES, DestructiveButton } from 'ui/button';

import { sentenceCase } from 'utils/stringHelpers';
import { PropsOf } from 'utils/reactHelpers';

import { DeletableItem, DeletableItemDisplayText } from '../types';
import { getItemsDeletionVerb, getItemsTypeName } from '../utils';

type ConfirmDeletionButtonProps = {
  content: DeletableItem[];
  folders: DeletableItem[];
  displayTextForContentItems: DeletableItemDisplayText;
} & PropsOf<typeof DestructiveButton>;

export const ConfirmDeletionButton = ({
  content,
  folders,
  displayTextForContentItems,
  ...buttonProps
}: ConfirmDeletionButtonProps) => {
  const deletionVerb = getItemsDeletionVerb(content, folders, displayTextForContentItems);
  const itemTypeName = getItemsTypeName(content, folders, displayTextForContentItems);
  const itemCount = content.length + folders.length;

  return (
    <DestructiveButton size={BUTTON_SIZES.LARGE} {...buttonProps}>
      {sentenceCase(deletionVerb)} {itemCount > 1 && itemCount} {itemTypeName}
    </DestructiveButton>
  );
};
